import type {
  ApprovalCalendarItemNode,
  ApproveWorkPeriodNode,
} from './types.graphql'

const plannedCalendarCategories = new Set(['WORK', 'OVERTIME'])

export type WorkPeriodApprovalRow = {
  type: 'workPeriod'
  id: string
  datetimeStart: string
  datetimeEnd: string
  user: ApproveWorkPeriodNode['user']
  calendarItem: ApproveWorkPeriodNode['calendarItem']
  workPeriod: ApproveWorkPeriodNode
}

export type CalendarItemApprovalRow = {
  type: 'calendarItem'
  id: string
  datetimeStart: string
  datetimeEnd: string
  user: NonNullable<ApprovalCalendarItemNode['user']>
  calendarItem: ApprovalCalendarItemNode
  workPeriod: null
}

export type ApprovalRow = WorkPeriodApprovalRow | CalendarItemApprovalRow

export function getApprovalRows(
  workPeriods: ApproveWorkPeriodNode[],
  calendarItems: ApprovalCalendarItemNode[]
): ApprovalRow[] {
  const workPeriodCalendarItemIds = new Set(
    workPeriods
      .map(workPeriod => workPeriod.calendarItem?.id)
      .filter((id): id is string => !!id)
  )

  const workPeriodRows: ApprovalRow[] = workPeriods.map(workPeriod => ({
    type: 'workPeriod',
    id: workPeriod.id,
    datetimeStart: workPeriod.datetimeStart,
    datetimeEnd: workPeriod.datetimeEnd,
    user: workPeriod.user,
    calendarItem: workPeriod.calendarItem,
    workPeriod,
  }))

  const plannedRows: ApprovalRow[] = calendarItems
    .filter(calendarItem => {
      if (!calendarItem.user) return false
      if (!plannedCalendarCategories.has(calendarItem.category)) return false
      if (workPeriodCalendarItemIds.has(calendarItem.id)) return false
      return !calendarItem.workPeriods.edges.some(edge => edge?.node?.id)
    })
    .map(calendarItem => ({
      type: 'calendarItem',
      id: calendarItem.id,
      datetimeStart: calendarItem.start,
      datetimeEnd: calendarItem.end,
      user: calendarItem.user as NonNullable<ApprovalCalendarItemNode['user']>,
      calendarItem,
      workPeriod: null,
    }))

  return [...workPeriodRows, ...plannedRows].sort((a, b) =>
    a.datetimeStart.localeCompare(b.datetimeStart)
  )
}
